import type { DraggableSyntheticListeners } from '@dnd-kit/core';

type Listener = (event: React.SyntheticEvent) => void;

/**
 * Слушатели перетаскивания для всей карточки: указатель и касание, без
 * клавиатуры.
 *
 * Клавиатурный на карточку вешать нельзя: Enter и пробел на названии или на
 * значке всплывают до карточки, и вместо открытия задачи начиналось бы
 * перетаскивание.
 *
 * Нажатия внутри раскрытого меню спринта карточку не берут: меню лежит в её
 * разметке, и выбор недели с дрожью руки в шесть пикселей превращался бы в
 * перенос карточки.
 */
export function pointerListeners(listeners: DraggableSyntheticListeners): Record<string, Listener> {
  const result: Record<string, Listener> = {};

  for (const [name, listener] of Object.entries(listeners ?? {})) {
    if (name === 'onKeyDown') continue;

    result[name] = (event) => {
      if (event.target instanceof Element && event.target.closest('.menu__list') !== null) return;
      (listener as Listener)(event);
    };
  }

  return result;
}
